import { OverridableStringUnion } from '@mui/types';
import { Box, Pill, styled } from '@/theme/index';

const StyledPill = styled(Pill)`
  position: absolute;
  top: -15px;
  right: -5px;
`;

export const GoldenTag = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  backgroundColor: theme.palette.premium.main,
  padding: theme.spacing(0.5),
  borderRadius: '0 0 0 4px',
  color: theme.palette?.premium?.contrastText || 'inherit',

  '&.align-left': {
    right: 'unset',
    left: 0,
  },
}));

type tagSizes = OverridableStringUnion<'small' | 'medium'>;

export interface DataCardTagProps {
  label: string;
  color: OverridableStringUnion<'primary' | 'success'>;
  size?: tagSizes;
}

export function DataCardTag({
  label,
  color,
  size = 'small',
}: DataCardTagProps) {
  return (
    <StyledPill data-testid="tag" label={label} color={color} size={size} />
  );
}

export function premiumProps(): DataCardTagProps {
  return {
    label: 'Premium',
    color: 'success',
  };
}

export function bonusProps(): DataCardTagProps {
  return {
    label: 'Bonus',
    color: 'primary',
  };
}

export function newInfoProps(): DataCardTagProps {
  return {
    label: 'New Info',
    color: 'primary',
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const tagTypeMapping: { [key: string]: any } = {
  premium: premiumProps,
  bonus: bonusProps,
  newInfo: newInfoProps,
};

/**
 *
 * @param tagName
 * @returns
 * getTagProps takes a `tagName` parameter and returns a monadic function.
 * This monadic function's argument is a string representing the desired DataCardTag's
 *`tagName`.
 */
const getTagProps = (tagName: string) => {
  return tagTypeMapping[tagName];
};

export interface DataCardTagTruthinessMapping {
  name: string;
  truthiness: boolean;
}

/**
 * build
 * @param tagName
 * @returns
 * build takes a TagTruthiness instance.
 * This monadic function's argument is a string representing the desired DataCardTag's
 * `tagName` and returns a function whose return value is a JSX.Element.
 */
export const build = (possibleTags: DataCardTagTruthinessMapping[]) => {
  const selectedTag = possibleTags.find((possibleTag) => {
    return possibleTag.truthiness === true;
  });

  if (selectedTag?.name) {
    const props = getTagProps(selectedTag.name)?.();
    return <DataCardTag {...props} />;
  }
};
